function renderWishlistPage() {
    var containers = document.querySelectorAll('.js-wishlist-content');
    if (!containers.length) return;

    // ਸਿਰਫ਼ ਪਹਿਲੇ ਕੰਟੇਨਰ ਨੂੰ ਰੱਖੋ, ਬਾਕੀ ਖਾਲੀ ਕਰੋ
    for (var i = 1; i < containers.length; i++) {
      containers[i].innerHTML = '';
    }

    var container = containers[0];
    var token = ++renderToken;
    
    // 1. 'Set' ਦੀ ਵਰਤੋਂ ਕਰਕੇ Array ਵਿੱਚੋਂ ਡੁਪਲੀਕੇਟ ਹੈਂਡਲਸ ਹਟਾਓ
    var rawList = getWishlist();
    var list = Array.from(new Set(rawList)); 

    if (!list.length) {
      container.innerHTML =
        '<div class="col-12 text-center">' +
          '<div class="alert alert-warning d-inline-block">There are no products in your wishlist!</div>' +
        '</div>';
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // 2. ਸਾਰੀਆਂ API ਕਾਲਾਂ ਨੂੰ ਇੱਕੋ ਵਾਰ ਪ੍ਰਬੰਧਿਤ ਕਰਨ ਲਈ Promises ਤਿਆਰ ਕਰੋ
    var fetchPromises = list.map(function (handle) {
      return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Product not found');
          return res.json();
        })
        .catch(function () {
          return null; // ਜੇ ਕੋਈ ਪ੍ਰੋਡਕਟ ਨਾ ਮਿਲੇ ਤਾਂ null ਰਿਟਰਨ ਕਰੋ
        });
    });

    // ਸਾਰੇ Promises ਪੂਰੇ ਹੋਣ ਦਾ ਇੰਤਜ਼ਾਰ ਕਰੋ
    Promise.all(fetchPromises).then(function (products) {
      // ਜੇਕਰ ਟੋਕਨ ਮੈਚ ਨਹੀਂ ਕਰਦਾ (ਮਤਲਬ ਕੋਈ ਨਵਾਂ ਰੈਂਡਰ ਸ਼ੁਰੂ ਹੋ ਗਿਆ), ਤਾਂ ਰੁਕ ਜਾਓ
      if (token !== renderToken) return;

      var combinedHtml = '';

      products.forEach(function (product) {
        if (!product) return; // null ਪ੍ਰੋਡਕਟਸ ਨੂੰ ਸਕਿੱਪ ਕਰੋ

        var price = product.price_varies
          ? 'from ' + formatMoney(product.price_min)
          : formatMoney(product.price);
        var compare = product.compare_at_price_min
          ? '<s>' + formatMoney(product.compare_at_price_min) + '</s>'
          : '';
        var img = product.featured_image || '';

        combinedHtml +=
          '<div class="js-wishlist-item col-md-4 col-sm-6 col-12 mb-4 pb-3">' +
            '<div class="js-wishlist-itembox">' +
              '<div class="d-flex flex-row">' +
                '<a class="d-inline-block mr-4 wl-left" href="' + product.url + '">' +
                  '<img src="' + img + '" alt="" width="120" loading="lazy" />' +
                '</a>' +
                '<div>' +
                  '<a href="' + product.url + '" class="title-product d-block product-card__name mb-1">' + product.title + '</a>' +
                  '<span>' + price + '</span> ' + compare +
                  '<p><button type="button" class="btn js-wishlist-remove link px-0 small" data-handle="' + product.handle + '">Remove</button></p>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>';
      });

      // ਪੁਰਾਣਾ ਡਾਟਾ ਸਾਫ਼ ਕਰਕੇ, ਸਾਰਾ ਨਵਾਂ HTML ਇੱਕੋ ਵਾਰ ਇੰਜੈਕਟ ਕਰੋ
      container.innerHTML = combinedHtml;
    });
}